import { ref, watch, computed } from "vue"

export function useFechas(destino) {

  const fechaIda = ref("")
  const fechaRegreso = ref("")

  const dias = ref("")
  const dias1 = ref(1)
  const dias2 = ref(1)

  // 🔥 HOY en formato YYYY-MM-DD
  const hoy = new Date()
  const minFecha = ref(hoy.toISOString().split("T")[0])

  function calcularRegreso(totalDias) {
    if (!fechaIda.value || !totalDias) return

    const f = new Date(fechaIda.value)
    f.setDate(f.getDate() + totalDias - 1)

    fechaRegreso.value = f.toISOString().split("T")[0]
  }

  const bloqueoRegreso = computed(() => {
    return (
      destino.value === "PERU" ||
      destino.value.includes("JPN") || destino.value.includes("BKK") ||
      destino.value.includes("COMBINADO")
    )
  })

  function calcularRegresoDesdeNoches(noches) {
    if (!fechaIda.value || !noches) return

    const f = new Date(fechaIda.value)
    f.setDate(f.getDate() + noches)

    fechaRegreso.value = f.toISOString().split("T")[0]
  }

  watch([fechaIda, destino, dias, dias1, dias2], () => {

    if (destino.value === "PERU") {
      calcularRegreso(dias.value)
      return
    }

    if (destino.value === "BKK") {
      calcularRegreso(dias.value + 1)
      return
    }

    if (destino.value.includes("JPN")) {
      calcularRegreso(dias.value)
      return
    }

    if (destino.value.includes("COMBINADO")) {
      calcularRegresoDesdeNoches(dias1.value + dias2.value)
      return
    }

    // normal → +1 día
    if (fechaIda.value) {
      const f = new Date(fechaIda.value)
      f.setDate(f.getDate() + 1)
      fechaRegreso.value = f.toISOString().split("T")[0]
    }

  })

  return {
    fechaIda,
    fechaRegreso,
    dias,
    dias1,
    dias2,
    bloqueoRegreso,
    minFecha // 🔥 EXPORTAR
  }
}